import PropTypes from 'prop-types'
import React from 'react'

import DynamicImage from 'components/DynamicImage'

import { PictureWrapper } from './styles'

const DHowFirstEuroBox = ({ path }) => (
  <PictureWrapper>
    <DynamicImage
      image={`${path}/dna-left-new`}
      imageType="png"
      imageSizes={{ xs: 420, md: 490 }}
      fitOption="contain"
      alt={'DNA test kit'}
    />
  </PictureWrapper>
)

DHowFirstEuroBox.propTypes = {
  path: PropTypes.string.isRequired,
}

export default DHowFirstEuroBox
